import React from 'react';
import { BlogPost } from '../types';

interface BlogCardProps {
  post: BlogPost;
  onClick?: () => void;
  onProfileView?: (username: string) => void;
}

const BlogCard: React.FC<BlogCardProps> = ({ post, onClick, onProfileView }) => {
  
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).format(date);
  };

  const formatReadTime = (minutes: number) => {
    return `${minutes} min read`;
  };

  return (
    <article className="blog-card" onClick={onClick}>
      <div className="blog-card-content blog-card-flex">
        {post.title && <h2 className="blog-card-title">{post.title}</h2>}
        <p className="blog-card-excerpt">{post.subtitle}</p>
        <div className="blog-card-author-row">
          <div className="blog-card-author" onClick={(e) => {
            e.stopPropagation();
            onProfileView?.(post.author_username);
          }}>
            <span className="author-name">@{post.author_username}</span>
          </div>
        </div>
        <div className="blog-card-bottom-row">
          <div className="blog-card-stats">
            <span className="blog-card-date">{formatDate(post.posted_at)}</span>
            <span className="blog-card-separator">•</span>
          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;